<lib-permissions-page (complete)="goToHome()" [permissions]="['location','notifications']"></lib-permissions-page>